export const APP_NAME = 'HOA One';
export const APP_ORIGIN = 'https://hoaone.app';
export const APP_MAIL_FROM = 'HOA One <hello@hoaone.app>';
export const APP_MAIL_REPLY_TO = 'hello@hoaone.app';
export const POSTMARK_MEMBER_INVITE_STREAM = 'member-invitation';
/** Legacy fallback when owner/tenant-specific templates are unset. */
export const POSTMARK_MEMBER_INVITE_TEMPLATE = 'user-invitation';
/** Postmark template alias for Owner invitations. */
export const POSTMARK_OWNER_INVITATION = 'owner-invitation';
/** Postmark template alias for Tenant invitations. */
export const POSTMARK_TENANT_INVITATION = 'tenant-invitation';
/** Postmark template alias for board member invitations. */
export const POSTMARK_BOARD_MEMBER_INVITATION = 'board-member-invitation';
/** Postmark template alias for forgotten-password emails (outbound stream). */
export const POSTMARK_PASSWORD_RESET_TEMPLATE = 'password-reset';
